
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './DataTable.scss'
const OrderGrid = ({ className, isActive, data, callback }) => {
  const classNameIcon = classNames('icon-sli cursor-pointer m-left-thin dataGrid-order', {
    'icon-arrow-1-down': !isActive,
    'icon-arrow-1-up': isActive
  })

  function handleclick () {
    callback(data)
  }

  return (
    <strong className={classNameIcon} onClick={handleclick} />
  )
}

OrderGrid.defaultProps = {
}

OrderGrid.propTypes = {
  isDesc: PropTypes.bool,
  className: PropTypes.string
}

export default OrderGrid
